import { useMutation } from '@apollo/client';
import { Button } from '@mui/material';
import { REJECT_USER_PHOTO } from '../../graphql/mutations-gql';
import { USER } from '../../graphql/queries-gql';
import { useDismissableSnackbar } from '../../hooks/useDismissableSnackbar';

export default function RejectUserPhoto({
  userId,
  uploadId,
}: {
  userId: string;
  uploadId: string;
}) {
  const { showSnackbar } = useDismissableSnackbar();
  const [rejectPhoto, { loading }] = useMutation<
    { rejectUserPhoto: string | null },
    { userId: string; uploadId: string }
  >(REJECT_USER_PHOTO, {
    refetchQueries: [{ query: USER, variables: { _id: userId } }],
    awaitRefetchQueries: true,
  });

  const handleReject = async () => {
    if (loading) return;
    try {
      const { data } = await rejectPhoto({ variables: { userId, uploadId } });
      if (data?.rejectUserPhoto !== 'OK') {
        throw new Error('Could not reject photo. Please try again.');
      }
      showSnackbar('Photo removed and marked for deletion', 'success');
    } catch (cause: unknown) {
      showSnackbar(
        cause instanceof Error ? cause.message : 'Could not reject photo. Please try again.',
        'error',
      );
    }
  };

  return (
    <Button
      size="small"
      variant="outlined"
      color="error"
      disabled={loading}
      onClick={handleReject}
    >
      {loading ? 'Rejecting...' : 'Reject photo'}
    </Button>
  );
}
